// extracted by mini-css-extract-plugin
module.exports =  {"layout":"Grid-module__layout___jOnzt","draggable":"Grid-module__draggable___Xkglg"};